var exports = {
  "a": "Box__bmPPJS",
};

module.exports = exports;
